/**
 * The form pane's header (Option C, C1, prototype `look/form.png`): the engine's icon, label and summary line from the
 * catalog. Its title names the pane (`<section aria-labelledby>`), so a screen reader hears the engine on focus entry.
 * In the short tier it is one 28-px line without the summary (plan §3.5).
 */
import { cn } from '@/lib/utils';
import { ConnectionEngineIcon, getEngineLabel } from '../../components/ConnectionEngineIcon';
import type { DatabaseEngine } from '../../components/connectionFormSchema';
import { findEngineCatalogEntry } from '../state/engineCatalog';

export const PANE_TITLE_ID = 'connection-pane-title';

export function ConnectionPaneHeader({ engine, short }: { engine: DatabaseEngine; short: boolean }) {
  // An engine the dialog does not offer (the e2e mock engine, in edit mode) still gets a named pane.
  const entry = findEngineCatalogEntry(engine);
  return (
    <div data-dialog-fixed className={cn('flex min-w-0 shrink-0 items-center gap-2.5 px-6', short ? 'py-1' : 'pb-2.5 pt-4')}>
      <ConnectionEngineIcon engine={engine} iconOnly size="lg" className={cn('shrink-0', short ? 'h-5 w-5' : 'h-6 w-6')} />
      <h3 id={PANE_TITLE_ID} className="whitespace-nowrap text-base font-semibold leading-5">
        {entry?.label ?? getEngineLabel(engine)}
      </h3>
      {!short && entry && <span className="min-w-0 truncate text-[13px] text-muted-foreground">{entry.summary}</span>}
    </div>
  );
}
